import { get } from 'lodash';

export default {
  validate: (question, visible, answers, payload, config, ln) => {
    return {
      visibleParts: answers[payload.question] && payload.part ? payload.part[get(answers[payload.question], 'part.id')] : []
    }
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/ShowPartsIfQuestionSelectionIs.js